import Age from "../../../Helpers/Dates/Age";

const insurancePolicyTypes = {
  INDIVIDUAL: 'Individual',
  SURVIVORSHIP: 'Survivorship'
}

const insurancePolicyTypeOption = () => {
  return [
    { value: insurancePolicyTypes.INDIVIDUAL, label: insurancePolicyTypes.INDIVIDUAL },
    { value: insurancePolicyTypes.SURVIVORSHIP, label: insurancePolicyTypes.SURVIVORSHIP }
  ]
}


const GetInflationBenefit = (isSurvivorshipPolicyType = false) => {
  return [
    { value: 'No Inflation', label: 'No Inflation' },
    { value: '3% Simple', label: '3% Simple' },
    { value: '5% Simple', label: '5% Simple' },
    { value: '3% Compound', label: '3% Compound' },
    ...(isSurvivorshipPolicyType &&
      [{ value: '3% Compound for 20 years', label: '3% Compound for 20 years' }]
    ),
    { value: '5% Compound', label: '5% Compound' },
  ];
}

const PremiumModesList = (isSurvivorshipPolicyType = false) => {
  return [
    { label: "Single Pay", value: "Single Pay" },
    { label: "2 Pay", value: "2 Pay" },
    { label: "3 Pay", value: "3 Pay" },
    { label: "4 Pay", value: "4 Pay" },
    { label: "5 Pay", value: "5 Pay" },
    { label: "7 Pay", value: "7 Pay" },
    { label: "10 Pay", value: "10 Pay" },
    { label: "15 Pay", value: "15 Pay" },
    ...(isSurvivorshipPolicyType &&
      [{ value: '20 Pay', label: '20 Pay' },]
    ),
    { label: "Pay to 65", value: "Pay to 65" },
    { label: "Pay to 100", value: "Pay to 100" },
  ];
}

const GetInterest = [
  { value: '0%', label: '0%' },
  { value: '3%', label: '3%' },
  { value: '6%', label: '6%' },
];

const Amount = () => {
  return [
    { value: 'Specific Amount', label: 'Enter Specific Amount' },
    { value: '50000', label: '$50,000.00' },
    { value: '100000', label: '$100,000.00' },
    { value: '150000', label: '$150,000.00' },
    { value: '200000', label: '$200,000.00' },
    { value: '250000', label: '$250,000.00' },
    { value: '300000', label: '$300,000.00' },
    { value: '350000', label: '$350,000.00' },
    { value: '400000', label: '$400,000.00' },
    { value: '450000', label: '$450,000.00' },
    { value: '500000', label: '$500,000.00' },
  ];
}

const SourceOfFunds = () => {
  return [
    { value: 'DirectBusiness', label: 'Direct Premiums To Carrier' },
    { value: 'ExchangeOrReplacement', label: '1035 Exchange/Replacement' },
  ];
}

const Purpose = () => {
  const purposeOptions = [
    { value: 'Asset Protection', label: 'Asset Protection' },
    { value: 'Estate Liquidity', label: 'Estate Liquidity' },
    { value: 'Income Replacement', label: 'Income Replacement' },
    { value: 'Final Expenses', label: 'Final Expenses' },
    { value: 'Special Needs Trust Funding', label: 'Special Needs Trust Funding' },
    { value: 'Retirement Planning', label: 'Retirement Planning' },
    { value: 'Business Planning', label: 'Business Planning' },
    { value: 'Other', label: 'Other' },
  ];

  return purposeOptions;
};

const getAsteriskNotationText = (value) => {
  return value === '84' ? 'Benefit Duration - 4 years' : 'Benefit Duration - 6 years';
}

const benefitDurationListToShowAsterisk = ['84', '86']; // showing Asterisk for this two benefitDuration value

//Show error message if PI age is not valid for selected premium mode
const checkPiAgeIsMatchWithAgeLimit = (premiumMode, state, isSurvivorshipPolicyType = false) => {
  //if premium mode value is '20 Pay', 'Pay to 65' or 'Pay to 100', then age limit is 30 to 65
  const isIncludesPremiumModeValue = ['20 Pay', 'Pay to 65', 'Pay to 100'].includes(premiumMode);
  const isAgeOutsideLimits = (age) => Age(age) >= 65 || Age(age) < 30;

  return !(isSurvivorshipPolicyType && isIncludesPremiumModeValue && (isAgeOutsideLimits(state.insuredBasicInfo.insuredInfo[0].birthdate) || isAgeOutsideLimits(state.insuredBasicInfo.insuredInfo.length > 1 && state.insuredBasicInfo.insuredInfo[1].birthdate)))
}

// helper function to normalize value (If a label is passed instead, it converts it to the corresponding value.)
const getNormalizedOptionValue = (value, options) => {
  const match = options.find(
    (opt) => opt.value === value || opt.label === value
  );
  return match ? match.value : value;
};


export {
  insurancePolicyTypes,
  insurancePolicyTypeOption,
  PremiumModesList, Amount, GetInflationBenefit, GetInterest, Purpose, SourceOfFunds,
  getAsteriskNotationText, benefitDurationListToShowAsterisk,
  checkPiAgeIsMatchWithAgeLimit,
  getNormalizedOptionValue,
}



// WEBPACK FOOTER //
// ./src/components/Product/ABLTC/SubComponents/SelectOptions.js